// DS: C59
/** A floating panel with links to share a deviation on social media */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useFlag } from '../../redux/flags/hooks';
import SocialShareButtons from '../../SocialShareButtons';
import CopyButton from './CopyButton';
import StandardDropdown from '../../Dropdown2/Preset/StandardDropdown';
import { ChatListSubscriptionStatus, ChatServiceStatus, } from '../../ChatV2/redux/types';
import { getChatServiceStatus } from '../../ChatV2/redux/selectors';
import ChatSummaryItem from '../../ChatV2/ChatSummaryItem';
import { ThemeOverride } from '../../Context';
import { ThemeOptions } from '../../publicSession';
import s from './DesktopSharePopup.scss';
var DesktopSharePopup = function (_a) {
    var url = _a.url, title = _a.title, thumbCode = _a.thumbCode, embedCode = _a.embedCode, media = _a.media, biData = _a.biData, isLoggedIn = _a.isLoggedIn, subscribeToChatList = _a.subscribeToChatList, chats = _a.chats, chatReduxReady = _a.chatReduxReady, chatListSubscriptionStatus = _a.chatListSubscriptionStatus;
    var t = useTranslation().t;
    var shareToChat = useFlag('share_to_chat');
    var chatServiceStatus = useSelector(getChatServiceStatus) || ChatServiceStatus.OFFLINE;
    var isChatReady = chatReduxReady &&
        chatServiceStatus === ChatServiceStatus.ONLINE &&
        chatListSubscriptionStatus === ChatListSubscriptionStatus.LISTENING;
    useEffect(function () {
        if (shareToChat &&
            chatServiceStatus === ChatServiceStatus.ONLINE &&
            chatListSubscriptionStatus !== ChatListSubscriptionStatus.LOADING &&
            chatListSubscriptionStatus !== ChatListSubscriptionStatus.LISTENING) {
            subscribeToChatList();
        }
    }, [
        shareToChat,
        chatServiceStatus,
        chatListSubscriptionStatus,
        subscribeToChatList,
    ]);
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['title'] }, t('share.shareOnSocial')),
        React.createElement(SocialShareButtons, { url: url, title: title || url, media: media, buttons: ['facebook', 'twitter', 'tumblr', 'pinterest'], iconSize: 42, iconBgColor: "#0e0d20" // L8
            , logoFillColor: "#00e59b" // G3
            , biData: biData }),
        shareToChat && isLoggedIn && isChatReady && (React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT },
            React.createElement(StandardDropdown, { usePortal: true, toggleClassName: s['chats-dropdown'], placeholder: (React.createElement("div", { className: s['chats-toggle'] }, t('share.chat'))), items: chats.map(function (chat) { return ({
                    value: chat.id,
                    label: (React.createElement(ChatSummaryItem, { chatroom: chat })),
                }); }) }))),
        React.createElement("div", { className: s['copy-title'] }, t('share.linkUrl')),
        React.createElement(CopyButton, { text: url, biData: biData }),
        false && (
        // disabled until editor supports thumbcodes
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: s['copy-title'] }, t('share.thumb')),
            React.createElement(CopyButton, { text: thumbCode || '' }))),
        embedCode && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: s['copy-title'] }, t('share.embed')),
            React.createElement(CopyButton, { text: embedCode, biData: biData })))));
};
DesktopSharePopup.displayName = 'DesktopSharePopup';
export default DesktopSharePopup;
//# sourceMappingURL=DesktopSharePopup.js.map